module.exports = __webpack_public_path__ + "img/vast-whey-2.0a6f997f.jpg";